<template>
    <div>

            <div v-for="(mod,i) in listModules" :key="i">
                <div v-if="!mod.module.dialog">
                <v-btn icon primary @click="close(i)" x-small><v-icon>mdi-close-thick</v-icon></v-btn>
                    <component
                    :key="key"  
                    v-bind:is="getComponent({component:mod.module.type})" 
                    :idmodule="mod.module.id" 
                    :modal="modal"
                    :page="page"
                    :form="form"
                    :customparams="mod.params"
                    :customquerys="mod.querys"
                    :storeTemplate="storeTemplate"
                    :keyTemplate="keyTemplate"
                    :hook="hook"
                    ></component>
                </div>

                <div v-if="mod.module.dialog">
                    <v-dialog
                    v-model="dialog"
                    :fullscreen="($vuetify.breakpoint.xs) ? true : false"
                    @click:outside="close(i)"
                    >
                    

                    <v-card>
                        <v-card-title class="grey lighten-2">
                        <v-btn icon @click="close(i)"><v-icon>mdi-close-thick</v-icon></v-btn>      
                        </v-card-title>

                        <v-card-text>
                            <component
                            :key="key"  
                            v-bind:is="getComponent({component:mod.module.type})" 
                            :idmodule="mod.module.id" 
                            :modal="modal"
                            :page="page"
                            :form="form"
                            :customparams="mod.params"
                            :customquerys="mod.querys"
                            :storeTemplate="storeTemplate"
                            :keyTemplate="keyTemplate"
                            :hook="hook"
                            ></component>
                        </v-card-text>


                    </v-card>
                    </v-dialog>        
                </div>            
            </div>


    </div>
    </template>
    
    
    
    <script>
  import OverLay from '../outils/overlay.vue'
        export default {
        props: ['page','modal','form','crochet','storeTemplate','keyTemplate','hook'],

        components : {
          OverLay

        },
            data: function() {
    
                return {

                    listModules : [],
                    paramsModule : {params:{},querys:{},module:{}},
                    params:{},
                    key : 0,
                    querys:{},
                    dialog : true,
                    module : {id:'',type:'',dialog:false},

                }
            },

        computed : {
            getVentilation() {
                return this.$store.getters['getVentilation']
            }
        },

        watch : {

            getVentilation(val) {
                val.forEach((ventil) => {
                    if((ventil.crochet == this.crochet && this.page == ventil.page) || (!this.crochet && ventil.crochet=='' && this.page == ventil.page)) {
                        var newModule = JSON.parse(JSON.stringify(this.paramsModule));

                        switch(ventil.type) {
                        case 'loadmodule' :
                        ventil.datas.forEach((data) => {
                            switch(data.typevar) {
                                case 'params' : 
                                newModule.params[data.key] = data.value 
                                break;
                                case 'query' : 
                                newModule.querys[data.key] = data.value 
                                break;
                            }
                            
                        })
                        break;
                    }
                    newModule.module = ventil.module
                    this.listModules.push(newModule);
                    this.$store.dispatch('removeVentilation',ventil)

                    }

                })
            }



        },

            methods :  {    
   

                initiateParams() {
                var modal = this.$store.getters.modalShowParams({ type: 'to', val: this.page })
                this.params = (this.modal && modal.show) ? modal.params : this.$route.params

                this.querys = (this.modal && modal.show) ? modal.query : this.$route.query
                },

                close(i) {
                    this.listModules = this.listModules.filter((el,u) => u!=i)
                }
                
            },
            mounted() {
                this.initiateParams()
            },
    
            created() {  

            }
    
        }
    
    </script>
    